/** * 顶部logo 导航菜单 */

<template>
  <div class="topnav">
    <div class="top-bg">
    <!-- logo -->
    <div
      class="u-position-absolute systemName"
      style="left: 50%; top: 50%; transform: translate(-50%, -50%)"
    >
      <p class="u-font-lg" style="font-size: 0.32rem; color: #fff">
        {{ appName }}
      </p>
    </div>
    <div class=" u-position-absolute u-w-100 u-l-0 u-t-0">
      <div class="u-myflex">
        <div class="u-flex-1"></div>
        <!-- 导航 -->
        <div v-if="allmenu.length > 0" class="u-flex-12">
          <div class="u-myflex u-j-center">
            <div
              v-for="(objitem, objindex) in allmenu"
              class="u-text-center u-flex-1"
              :style="{
                marginRight: objindex == Math.floor(allmenu.length / 2) ? '8.2rem' : '',
              }"
              :class="{
                active: menuindex === objindex,
              }"
              :key="objitem.id||objindex"
              @mouseenter="enters(objindex)"
              @mouseleave="leaver(objindex)"
            >
              <a
                class="title-heading"
                :class="[activeNav1 === objindex&&'u-color-warning',!objitem.id&&'clear-a']"
                href="javascript:;"
                @click.stop="toggle(objitem, objindex)"
              >
                {{ objitem.name }}
             <template v-if="objitem.children">
                 <transition name="fade">
                  <div
                    v-show="isshowindex === objindex"
                    class="heading-children u-flex-column"
                  >
                    <a
                      @click.stop="toggleA(item, objindex, item.id)"
                      v-for="(item, index) in objitem.children"
                      :key="index"
                      href="javascript:;"
                      :class="['toggle-a-' + item.id]"
                    >
                      <span>{{ item.name }}</span>
                    </a>
                  </div>
                </transition>
             </template>
              </a>
            </div>
            <div v-if="allmenu.length % 2 != 0" class="u-flex-1"></div>
          </div>
        </div>
        <!-- <div class="cb"></div> -->

        <div class="u-flex-1 u-myflex">
          <!-- 新下拉菜单 -->
          <div class="u-flex-1"></div>
          <div style="width: 80px; padding-top: 10px" >
            <el-dropdown class="el-dropdown-link u-m5-r-2">
              <!-- <span style="font-size: 25px; color: rgb(82, 241, 241);"  class="iconfont icon-jiaoche" @mouseenter="getInitCars()"><sup style="font-size: 10px;">{{cars}}</sup></span> -->
              <img style="width: 0.42rem; height: 0.42rem" :src="notice" @mouseenter="getCars(1,2)"/><div style="font-size: 8px;color:rgb(82, 241, 241);position: absolute; top:-20px; left:22px; display:inline;">{{cars}}</div>
              <el-dropdown-menu slot="dropdown">
                <div>
                  <!-- <div class="u-p5-t-1 u-text-center u-color-white">
                    <div class="u-m5-r-2 u-font-md">车辆即将过期提醒:  {{cars}}条数据     <el-button size="mini" type="primary" @click="sort('asc')">升序</el-button><el-button size="mini" @click="sort('desc')">降序</el-button></div>
                  </div> -->
                  <div class="u-myflex u-flexwrap u-p5-2" style="width: 520px;height: 300px;overflow-y:scroll;" ref="CarsData">

                    <!-- <el-table v-loading="loading" element-loading-text="数据载入中" element-loading-spinner="el-icon-loading" :data="pageList" height="300" :show-overflow-tooltip="true">
                      <el-table-column align="center" label="所属企业" prop="coName" sortable show-overflow-tooltip/>
                      <el-table-column align="center" label="司机姓名" prop="name" width="100" sortable/>
                      <el-table-column align="center" label="车牌号码" prop="plateNo" width="100" sortable/>
                      <el-table-column align="center" label="有效期止" prop="validityPeriodEnd" width="100" sortable/>
                      <el-table-column align="center" label="剩余天数" prop="plateColor" width="80">
                        <template slot-scope="scope">
                          <span >{{parseInt(Math.abs(new Date(scope.row.validityPeriodEnd) - new Date(curDate)) / 1000 / 60 / 60 / 24)+1}}</span>
                        </template>
                      </el-table-column>
                    </el-table> -->

                    <div v-for="(item, index) in pageList" :key="index" > 
                      <h4 style="color:white">{{ item.coName }}的车辆 <span style="color:rgb(82, 241, 241);">{{item.plateNo}}</span> 即将在<span style="color:yellow">{{parseInt(Math.abs(new Date(item.validityPeriodEnd) - new Date(curDate)) / 1000 / 60 / 60 / 24)+1}}</span>天后过期</h4>
                    </div>
                  </div>
                  <div style="text-align: center;" v-show="loading">
                        <i style="font-size: 0.3rem;color:white" class="el-icon el-icon-loading"></i>
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div style="width: 50px; padding-top: 10px">
            <el-dropdown class="el-dropdown-link u-m5-r-2">
              <img style="width: 0.42rem; height: 0.42rem" src="static/img/logo1.png" />
              <el-dropdown-menu slot="dropdown">
                <div>
                  <div class="u-p5-t-1 u-text-center u-color-white">
                    <div class="u-m5-r-2 u-font-md">{{ username }}</div>
                  </div>
                  <div class="u-myflex u-flexwrap u-p5-2" style="width: 260px">
                    <div
                      v-for="(item, i) in sysmenu"
                      :key="i"
                      class="u-span24-12 u-text-center u-m5-b-2"
                    >
                      <el-button size="small" @click.native="toggleB(item, i)">{{
                        item.name ? item.name : ""
                      }}</el-button>
                    </div>
                    <div class="u-span24-12 u-text-center u-m5-b-2">
                      <el-button size="small" @click.stop="changePwd">修改密码</el-button>
                    </div>
                    <div class="u-span24-12 u-text-center">
                      <el-button size="small" @click.stop="exitPC">退出系统</el-button>
                    </div>
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <!-- <div style="margin-top: 0.6rem">
      预留下边条-------------------------------------------------------
      ----------------------------------------------------------------
      -----------------------------------------------------------------
    </div> -->
    <!-- 隐藏菜单 -->
    <el-dialog
      class="xgmm"
      title="修改密码"
      :visible.sync="changeVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="pwdForm"
        label-position="right"
        :model="params"
        class="tl pl30 pr30"
        label-width="100px"
        :rules="rules"
      >
        <!-- <el-form-item label="原密码" prop="oldPassword">
          <el-input
            type="password"
            v-model="params.oldPassword"
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="新密码" prop="password">
          <el-input
            type="password"
            v-model="params.newpassword"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="truePassword">
          <el-input
            type="password"
            v-model="params.truePassword"
            placeholder="请确认新密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="tr mt10">
          <el-button @click="submitPwd">提交</el-button>
          <el-button @click.native="changeVisible = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import webconfig from "@/web.config.js";
import { mapMutations, mapState } from "vuex";

export default {
  name: "topnav",
  data() {
    const confirmPwd = (rule, value, callback) => {
      if (this.params.newpassword !== value) {
        return callback(new Error("确认密码与新密码输入不一致！"));
      } else {
        callback();
      }
    };
    return {
      userid:JSON.parse(localStorage.getItem('userid')),
      activeNav1: 0,
      menuindex: 0,
      isshowindex: -1,
      appName: webconfig.appName,
      username:window.localStorage.getItem('nickname'),
      notice:'static/img/news2.png',
      noticeNum:0,
      saveTimer: null,
      pageList:[],
      //loading: true,
      cars:0,
      setTimer: null,
      isEnd: false,
      loading: false,
      curDate: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd 00:00:00"),
      queryParams: {
          limit: 20,
          page: 1,
        },
      apiUrl: {
          indexApi: 'POST_getReExpire',
        },
      allmenu: [
        // {
        //   id: 'a1',
        //   objindex: 'a1',
        //   menuName: 'a1',
        //   menus: [
        //     {
        //       menuId: 'm1',
        //       menuName: 'm1'
        //     },
        //     {
        //       menuId: 'm2',
        //       menuName: 'm2'
        //     },
        //     {
        //       menuId: 'm3',
        //       menuName: 'm3'
        //     }
        //   ]
        // }
      ],
      sysmenu: [
        // {
        //   menuName: '1',
        //   id: 'id1'
        // },
        // {
        //   menuName: '2',
        //   id: 'id2'
        // },
        // {
        //   menuName: '3',
        //   id: 'id3'
        // }
      ],
      changeVisible: false,
      params: {newpassword:"",truePassword:""}, // 修改密码弹窗数据
      rules: {
        //oldPassword: [{ required: true, message: "请输入原密码" }],
        newpassword: [{ required: true, message: "请输入新密码" }],
        truePassword: [
          { required: true, message: "请确认新密码" },
          { validator: confirmPwd, trigger: "blur" },
        ],
      },
      // rules: {
      //   //oldPassword: [{ required: true, message: "请输入原密码" }],
      //   newpassword: [{ required: true, message: "请输入新密码" }],
      //   truePassword: [
      //     { required: true, message: "请确认新密码" },
      //     { validator: confirmPwd, trigger: "blur" },
      //   ],
      // },
    };
  },
  computed: {
    ...mapState({
      ativeNavbar: (state) => state.topnav_activeNav1,
      vuex_allmenu: (state) => state.vuex_allmenu,
    }),
  },
  methods: {
    ...mapMutations(["topnav_activeNav1", "documentTitle_menuName","SET_sbNav","SET_allMenu"]),
    changePwd() {
      const id = this.userid;
      this.$prompt('请输入新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: value => {
          if (!value || value.trim().length < 1) {
            return "请填写新密码";
          }
        }
      })
        .then(({ value }) => {
          //let newPassword = this.$aes.encrypt(value);//加密
          this.$http.PATCH_adminUsersUpdate2({
            paramsID: id,
            password: value,
            status: 1
          }).then((res) => {
            if(res.code == '00000'){
              this.$message.success("修改成功，新密码是：" + value);
            }else{
              this.$message.error(res.msg)
            }
          });
        })
        .catch(() => {});
    },
    getCars(page,type) {
      if(page == 1){
        this.pageList = [];
        this.isEnd=false;
      }
      this.queryParams.page = page;
      this.$http[this.apiUrl.indexApi](this.queryParams).then(response => {
            const {data,total} = response;
            if(response.code=='00000'&&data.length >0){
              this.pageList = this.pageList.concat(data);
              //this.pagination.total = total;
              this.cars = total;
              this.loading = false;
              this.sort('asc');
              if(type == 1 && total>this.noticeNum){
                this.notice = 'static/img/news.png';
                this.noticeNum = total;
              }
              if(type == 2){
                this.notice = 'static/img/news2.png'
              }
            }else{
              if(page != 1){
                this.$message("数据已请求完")
              }
              this.notice = 'static/img/news2.png'
              this.isEnd=true
              this.loading = false;
            }

          });
    },
    sort(type){
      this.pageList.sort(function(a, b) {
        let obj1 = a['validityPeriodEnd']
        let obj2 = b['validityPeriodEnd']
        const val1 = Math.floor(new Date(obj1).getTime() / 1000)
        const val2 = Math.floor(new Date(obj2).getTime() / 1000)
        if(type == 'asc'){
          return val1 - val2
        }
        if(type == 'desc'){
          return val2 - val1
        }
      });
    },
    scroll(e) {
      const bottomHeight = e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
      if (bottomHeight < 30&&!this.isEnd) {
        this.loading = true;
        if (this.setTimer) clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          this.queryParams.page += 1;
          this.getCars(this.queryParams.page,2);
        }, 500);
      }
    },
    getAllMenus() {
      // if(this.vuex_allmenu.length){
      //   this.allmenu = this.vuex_allmenu
      //   return
      // }
      this.$http.GET_menusList({ params: { queryMode: "index" } }).then((res) => {

        window.localStorage.menu = JSON.stringify(res.data);
        //根据id升序排序
        var asc = function(x,y){
            return (x.id > y.id) ? 1 : -1
        }
        //返回数据排序乱序时才需要重新排序
        res.data.sort(asc);
        if(!res.data[1].children)throw("申报菜单 children没有数据")
        res.data[1].children.sort(asc);
        res.data=res.data.slice(0,7)

        let documentTitle = {};
        this.allmenu = res.data.map((element, index) => {
          if(element.id=== "207"){
            element.children.forEach(item => {
              item.children&&item.children.forEach(item2 => {
                documentTitle[item2.id]= element.name;
              });
            });
            this.SET_sbNav(JSON.parse(JSON.stringify(element.children)))
            element.children=null;
          }
          if (element.children) {
            element.children.map((element2) => {
              if (!documentTitle[element2.id])
                documentTitle[element2.id] = element.name;

              element2.parentIndex = index;
              return element2;
            });
          } else {
            if (!documentTitle[element.id]) documentTitle[element.id] = element.name;
          }
          return element;
        });
        const temp =new Array(7).fill({
          name: ''
        })
        console.log(this.allmenu)
        this.allmenu=Object.assign(temp,this.allmenu)
        this.SET_allMenu(this.allmenu)
        this.$store.commit("documentTitle", documentTitle);
      });
    },
    getSysMenus() {
      this.$http.GET_menus().then((res) => {
        this.sysmenu = res.sysmenu;
      });
    },
    jumpRouter(menuId, menuName) {
      this.$router.push({
        name: menuId,
      });
      // sessionStorage.setItem()
    },
    toggle(item, menuindex) {
      this.activeNav1 = menuindex;
      this.topnav_activeNav1(this.activeNav1);
      if (!item.children) this.jumpRouter(item.id, item.name);
    },
    toggleA(item, menuindex) {
      this.activeNav1 = item.parentIndex;
      this.topnav_activeNav1(this.activeNav1);
      const documentTitle_menuName = {};
      documentTitle_menuName[item.id] = item.name;
      this.documentTitle_menuName(documentTitle_menuName);
      this.jumpRouter(item.id, item.name);
    },
    toggleB(item, menuindex) {
      this.jumpRouter(item.sysId, item.menuName);
    },
    exitPC() {
      this.$emit("exitlogin");
    },
    enters(index) {
      this.isshowindex = index;
    },
    leaver() {
      this.isshowindex = -1;
    },
    submitPwd() {
    },
  },
  created() {
    this.getAllMenus();
    this.getSysMenus();
    this.getCars(1,1);
    this.activeNav1 = this.ativeNavbar;
    this.saveTimer = setInterval(() => {
      this.getCars(1,1);
    }, 180000);
  },
  mounted() {
    this.$refs.CarsData.addEventListener("scroll", this.scroll);
  },
  destroyed() {
    clearInterval(this.saveTimer);
    //  this.$refs.CarsData.removeEventListener("scroll", this.scroll);
  },
  watch: {
    ativeNavbar: {
      handler: function (nval) {
        this.activeNav1 = nval;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.clear-a:hover{
  cursor:default;
}
.systemName {
  width: 10.2rem;
  text-align: center;
  height: 0.9rem;
  line-height: 0.9rem;
  background: url(../../../static/img/system_title_bg.png) no-repeat;
  background-size: 100% 100%;
}
.topnav {
  line-height: 0.7rem;
  background-image: linear-gradient(to right,#051736, rgba(27, 83, 136, 0.5), #051736);
  // background: rgba(16,60,101,0.6);
  height: 0.7rem;
  width: 100%;
  // border-bottom: 1px #054b76 solid;
  .top-bg{
    width: 100%;
    height: 100%;
  background: url(../../../static/img/top_bg.png) no-repeat;
  background-size: 100% 100%;}
  .title-heading {
    color: #a8fcff;
    min-width: 1rem;
    height: 100%;
    display: block;
    font-size: 0.22rem;
    padding: 0 0.12rem;
    position: relative;
  }

  .heading-children {
    background: #0f3866;
    flex-wrap: wrap;
    position: absolute;
    left: 50%;
    top: 0.7rem;
    transform: translate(-50%);
    a {
      display: block;
      background: url(/static/img/childbtn.png) no-repeat;
      background-size: 100% 100%;
      width: 100%;
      min-width: 1.4rem;
      height: 0.4rem;
      line-height: 0.4rem;

      span {
        display: inline-block;
        color: #fff;
        font-size: 0.2rem;
        font-weight: bold;
      }
    }

    .active-dom {
      background-color: none;
      background: url(/static/img/childbtn-hover.png) no-repeat;
      background-size: contain !important;
    }

    a:hover {
      background-color: none;
      background: url(/static/img/childbtn-hover.png) no-repeat;
      background-size: 100%;

      span {
        color: #fff;
      }
    }

    a.cur {
      background: url(/static/img/childbtn-hover.png) no-repeat;
      background-size: contain;

      span {
        color: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/topnav.vue